import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import './index.css';

import { Provider as ReduxProvider, useSelector } from 'react-redux';
import store, { persistor } from './redux/store';
import { PersistGate } from 'redux-persist/integration/react';

import { msalConfig } from './authConfig.js';
import App from './App';
import { BrowserRouter } from 'react-router-dom';

export const msalInstance = new PublicClientApplication(msalConfig);

// Listen for sign-in event and set active account
msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
    const account = event.payload.account;
    msalInstance.setActiveAccount(account);
  }
});

function renderApp() {
  if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
  }

  msalInstance.enableAccountStorageEvents();

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <ReduxProvider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter basename="/">
            <App instance={msalInstance} />
          </BrowserRouter>
        </PersistGate>
      </ReduxProvider>
    </React.StrictMode>
  );
}

msalInstance.initialize().then(() => {
  return msalInstance.handleRedirectPromise();
}).then((response) => {
  if (response) {
    msalInstance.setActiveAccount(response.account);
  }
  renderApp();
}).catch((error) => {
  console.error('[MSAL Redirect Error]', error);
  // Clear stale interaction state that caused the error, then render anyway
  Object.keys(sessionStorage).forEach((key) => {
    if (key.includes('msal.')) {
      sessionStorage.removeItem(key);
    }
  });
  renderApp();
});
